import React from 'react';

import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {assertAndContinue} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {MainViewComponentProps, StepAwareAnalysisMainViewItemType} from './MainViewTypes';
import ThirdPartyStepHeader from './third-party-step/ThirdPartyStepHeader';

/** @package */
export function doesStepSupportHeader(step: GetAnalysisPipelineStep): boolean {
  return step.definition.stepType === PipelineStepType.THIRD_PARTY;
}

/**
 * Render step header if the step supports it
 *
 * The caller should only render this component if `doesStepSupportHeader(step)` is true.
 *
 * @package
 */
export default function StepHeaderRouter(
  props: Omit<MainViewComponentProps<StepAwareAnalysisMainViewItemType>, 'selectedItem'>
): JSX.Element | null {
  assertAndContinue(doesStepSupportHeader(props.step), 'Step does not support header');

  if (props.step.definition.stepType === PipelineStepType.THIRD_PARTY) {
    return <ThirdPartyStepHeader {...props} />;
  }

  return null;
}
